import { useMemo } from 'preact/hooks';

export function useIdGen(items: Array<{ id: number }>) {
  return useMemo(() => {
    let id = items.reduce((acc, b) => (acc > b.id ? acc : b.id), 0) + 1;
    return () => ++id;
  }, []);
}
